(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s2t-cta"] && !Shopify.designMode) return;
  try {
    
  // ---------- Open modal ----------
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-s2t-cta-open]');
    if (!trigger) return;
    e.preventDefault();
    var modal = document.getElementById(trigger.getAttribute('data-s2t-cta-open'));
    if (!modal) return;
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      // Fallback for ancient browsers — just toggle the open attribute.
      modal.setAttribute('open', '');
    }
    // Move focus into the first input for keyboard / screen-reader users.
    var firstInput = modal.querySelector('input, textarea, select');
    if (firstInput) {
      try { firstInput.focus({ preventScroll: true }); } catch (e) { firstInput.focus(); }
    }
  });

  // ---------- Close modal (X button, ESC handled natively by <dialog>) ----------
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-s2t-cta-close]');
    if (closer) {
      var modal = closer.closest('dialog');
      if (modal && typeof modal.close === 'function') modal.close();
      return;
    }
    // Click on the dialog backdrop itself (not its children) — close.
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('s2t-cta-modal')) {
      var rect = e.target.getBoundingClientRect();
      var inViewportBackdrop = (
        e.clientY < rect.top || e.clientY > rect.bottom ||
        e.clientX < rect.left || e.clientX > rect.right
      );
      // The default Chrome behavior considers backdrop clicks as targeting
      // the <dialog> element. We close on those.
      if (inViewportBackdrop || e.target === e.currentTarget) {
        try { e.target.close(); } catch (err) {}
      }
    }
  });

  // ---------- Form submit → POST to GHL webhook ----------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-s2t-cta-form]');
    if (!form) return;
    e.preventDefault();

    var webhook = form.getAttribute('data-webhook');
    var statusEl = form.querySelector('[data-s2t-cta-status]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var submitLabel = submitBtn ? submitBtn.querySelector('.s2t-cta-modal__submit-label') : null;
    var defaultLabel = submitBtn ? (submitBtn.getAttribute('data-default-label') || (submitLabel ? submitLabel.textContent : 'Submit')) : 'Submit';
    var loadingLabel = submitBtn ? (submitBtn.getAttribute('data-loading-label') || 'Sending…') : 'Sending…';
    var successMsg = form.getAttribute('data-success-message') || 'Thanks!';
    var errorMsg = form.getAttribute('data-error-message') || 'Something went wrong. Please try again.';
    var successBehavior = form.getAttribute('data-success-behavior') || 'message';
    var successRedirect = form.getAttribute('data-success-redirect') || '';
    var sourceLabel = form.getAttribute('data-source-label') || '';
    var tagsRaw = form.getAttribute('data-tags') || '';
    var tags = tagsRaw
      ? tagsRaw.split(',').map(function (t) { return t.trim(); }).filter(Boolean)
      : [];

    function setStatus(text, kind) {
      if (!statusEl) return;
      statusEl.textContent = text || '';
      statusEl.classList.remove('s2t-cta-modal__status--success', 's2t-cta-modal__status--error');
      if (kind) statusEl.classList.add('s2t-cta-modal__status--' + kind);
    }
    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      submitBtn.classList.toggle('s2t-cta-modal__submit--loading', loading);
      if (submitLabel) submitLabel.textContent = loading ? loadingLabel : defaultLabel;
    }

    if (!webhook) {
      setStatus('Form not yet configured. Please contact us directly.', 'error');
      return;
    }

    // Collect fields
    var data = new FormData(form);
    var nameValue = (data.get('name') || '').toString().trim();
    var emailValue = (data.get('email') || '').toString().trim();
    var phoneValue = (data.get('phone') || '').toString().trim();

    // Split full-name into first / last so GHL can map both directly.
    var firstName = '';
    var lastName = '';
    if (nameValue) {
      var parts = nameValue.split(/\s+/);
      firstName = parts.shift();
      lastName = parts.join(' ');
    }

    var payload = {
      name: nameValue,
      first_name: firstName,
      last_name: lastName,
      email: emailValue,
      phone: phoneValue || undefined,
      source: sourceLabel,
      tags: tags,
      page_url: window.location.href,
      submitted_at: new Date().toISOString()
    };

    setLoading(true);
    setStatus('');

    fetch(webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'omit'
    })
      .then(function (r) {
        // GHL webhooks return 200 on success. Anything else → error.
        if (!r.ok) throw new Error('Webhook returned status ' + r.status);
        return r.text().catch(function () { return ''; });
      })
      .then(function () {
        setLoading(false);
        setStatus(successMsg, 'success');
        // Disable the form so it can't be double-submitted.
        var inputs = form.querySelectorAll('input, button');
        inputs.forEach(function (el) { el.disabled = true; });

        if (successBehavior === 'redirect' && successRedirect) {
          setTimeout(function () { window.location.href = successRedirect; }, 1200);
          return;
        }
        if (successBehavior === 'message') {
          // Auto-close after 3s.
          var modal = form.closest('dialog');
          setTimeout(function () {
            if (modal && typeof modal.close === 'function') modal.close();
            // Reset form so it's ready for next time the modal is opened.
            setTimeout(function () {
              form.reset();
              inputs.forEach(function (el) { el.disabled = false; });
              setStatus('');
            }, 600);
          }, 3000);
        }
        // "manual" behavior: leave modal open, status message stays.
      })
      .catch(function (err) {
        console.error('[s2t-cta] Webhook submit failed:', err);
        setLoading(false);
        setStatus(errorMsg, 'error');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2t-patches-faq-rail"] && !Shopify.designMode) return;
  try {
    
  // ---------- Rail arrows ----------
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-s2t-fr-nav]');
    if (!nav) return;
    var wrap = nav.closest('.s2t-patches-faq-rail__rail-wrap');
    if (!wrap) return;
    var track = wrap.querySelector('[data-s2t-fr-track]');
    if (!track) return;
    var dir = parseInt(nav.getAttribute('data-s2t-fr-nav'), 10) || 1;
    var card = track.querySelector('.s2t-patches-faq-rail__card');
    var step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  // ---------- Rail add to cart ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s2t-fr-add]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var labelDefault = btn.getAttribute('data-label-default') || 'Add to Cart';
    var labelAdding = btn.getAttribute('data-label-adding') || 'Adding…';
    var labelAdded = btn.getAttribute('data-label-added') || 'Added ✓';

    btn.disabled = true;
    btn.textContent = labelAdding;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function (data) {
        try { window.dispatchEvent(new CustomEvent('s2t:cart-updated', { bubbles: true, detail: data })); } catch (err) {}
        if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (err) {} }
        btn.textContent = labelAdded;
        setTimeout(function () { btn.disabled = false; btn.textContent = labelDefault; }, 1500);
      })
      .catch(function (err) {
        console.error('[s2t-patches-faq-rail] Add to cart failed:', err);
        btn.disabled = false;
        btn.textContent = labelDefault;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2t-patches-hero"] && !Shopify.designMode) return;
  try {
    
  // ============================================================
  // Gallery: thumbnail → main image swap (delegated)
  // ============================================================
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-s2t-ph-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('.s2t-patches-hero__gallery');
    if (!gallery) return;
    var main = gallery.querySelector('[data-s2t-ph-main]');
    if (!main) return;

    var full = thumb.getAttribute('data-full');
    var srcset = thumb.getAttribute('data-srcset');
    var alt = thumb.getAttribute('data-alt');
    if (full) main.setAttribute('src', full);
    if (srcset) main.setAttribute('srcset', srcset);
    if (alt) main.setAttribute('alt', alt);

    var all = gallery.querySelectorAll('[data-s2t-ph-thumb]');
    for (var i = 0; i < all.length; i++) {
      var isActive = (all[i] === thumb);
      all[i].classList.toggle('s2t-patches-hero__thumb--active', isActive);
      all[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  });

  // ============================================================
  // Quantity stepper
  // ============================================================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s2t-pa-qty-step]');
    if (!btn) return;
    var row = btn.closest('.s2t-patches-hero__qty');
    if (!row) return;
    var input = row.querySelector('[data-s2t-pa-qty]');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-s2t-pa-qty-step'), 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;
    input.value = next;
    // Let the options app recalculate tiered pricing off the new quantity.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ============================================================
  // Per-patch header price, derived from the app's live total
  //
  // Live Product Options rewrites elements carrying
  // data-live-price-quantity (the TOTAL row) but, in practice, not ones
  // with data-live-price alone. So the header is computed here as
  // total / quantity, where quantity is the app's own Quantity option
  // (the last [name="quantity"] in the form). It reflects the size
  // add-on and the bulk tier alike: $101.25 / 25 -> $4.05 each.
  // ============================================================
  (function () {
    function parseMoney(text) {
      var n = parseFloat(String(text).replace(/[^0-9.]/g, ''));
      return isNaN(n) ? null : n;
    }
    function formatLike(sample, value) {
      // Reuse the sample's currency prefix / suffix so "$" or " USD" carry over.
      var m = String(sample).trim().match(/^([^0-9]*)[0-9][0-9.,]*([^0-9]*)$/);
      var prefix = m ? m[1] : '$';
      var suffix = m ? m[2] : '';
      var parts = value.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + parts.join('.') + suffix;
    }
    function wire(section) {
      var priceEl = section.querySelector('[data-s2t-pa-price]');   // header, per-patch mode only
      var subEl = section.querySelector('[data-s2t-pa-total-sub]'); // "[qty] pcs · [each] ea" under the total
      var totalEl = section.querySelector('[data-s2t-pa-total]');
      var form = section.querySelector('[data-s2t-pa-form]');
      if (!totalEl || (!priceEl && !subEl)) return;

      function update() {
        var total = parseMoney(totalEl.textContent);
        if (total === null) return;
        var qty = 1;
        if (form) {
          var inputs = form.querySelectorAll('[name="quantity"]');
          if (inputs.length) qty = parseInt(inputs[inputs.length - 1].value, 10) || 1;
        }
        if (qty < 1) qty = 1;
        var each = formatLike(totalEl.textContent, total / qty);
        if (priceEl) priceEl.textContent = each;
        if (subEl) {
          var fmt = subEl.getAttribute('data-format') || '[qty] pcs · [each] ea';
          subEl.textContent = fmt.split('[qty]').join(String(qty)).split('[each]').join(each);
        }
      }

      new MutationObserver(update).observe(totalEl, { childList: true, characterData: true, subtree: true });
      if (form) {
        form.addEventListener('input', update);
        form.addEventListener('change', update);
      }
      update();
    }
    function init() {
      var sections = document.querySelectorAll('.s2t-patches-hero');
      for (var i = 0; i < sections.length; i++) wire(sections[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ============================================================
  // Add to cart
  //
  // FormData(form) captures every field the Upload Lift and Live Product
  // Options app embeds inject into this form, including properties[…], so
  // uploaded artwork and the chosen size/shape/colour reach the cart.
  //
  // "After adding to cart":
  //   drawer     → AJAX add, then open the cart drawer (default)
  //   cart_page  → AJAX add, then navigate to /cart
  //   stay       → AJAX add, label feedback only
  //   native     → do NOT intercept; let the browser submit the form so an
  //                app that owns the submit event (e.g. Upload Lift gating
  //                ATC until the upload completes) keeps working.
  // ============================================================
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-s2t-pa-form]');
    if (!form) return;

    var behavior = form.getAttribute('data-cart-behavior') || 'drawer';
    if (behavior === 'native') return; // hand off to the browser / the app

    e.preventDefault();

    var submitBtn = form.querySelector('[data-s2t-pa-atc]');
    var labelEl = form.querySelector('.s2t-patches-hero__atc-label');
    var defaultLabel = form.getAttribute('data-label-default') || (labelEl ? labelEl.textContent.trim() : 'Add to Cart');
    var addingLabel = form.getAttribute('data-label-adding') || 'Adding…';
    var addedLabel = form.getAttribute('data-label-added') || 'Added ✓';
    var errorMessage = form.getAttribute('data-error-message') || 'Sorry, we couldn\'t add this to your cart. Please try again.';

    function setLabel(t) { if (labelEl) labelEl.textContent = t; }
    function setLoading(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      submitBtn.classList.toggle('s2t-patches-hero__atc--loading', on);
    }
    function restore() {
      setTimeout(function () { setLoading(false); setLabel(defaultLabel); }, 1500);
    }

    var errorEl = form.querySelector('[data-s2t-pa-error]');
    function showError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
      else { try { window.alert(msg); } catch (e2) {} }
    }
    if (errorEl) errorEl.hidden = true;

    // Minimum order per design. The options app's Quantity control enforces
    // the same floor in its UI; this is the belt to that suspenders, since
    // Shopify itself has no per-line minimum.
    var minQty = parseInt(form.getAttribute('data-min-quantity'), 10) || 1;
    var qtyInputs = form.querySelectorAll('[name="quantity"]');
    var qty = qtyInputs.length ? (parseInt(qtyInputs[qtyInputs.length - 1].value, 10) || 0) : 1;
    if (qty < minQty) {
      showError(form.getAttribute('data-min-quantity-message') || ('Minimum order is ' + minQty + '.'));
      return;
    }

    setLoading(true);
    setLabel(addingLabel);

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error((data && (data.description || data.message)) || errorMessage);
          }
          return data;
        });
      })
      .then(function (data) {
        try {
          window.dispatchEvent(new CustomEvent('s2t:cart-updated', { bubbles: true, detail: data }));
        } catch (err) {}

        if (behavior === 'cart_page') { window.location.href = '/cart'; return; }
        if (behavior === 'stay') { setLabel(addedLabel); restore(); return; }

        // Refresh first so the count/lines are current before the panel opens.
        if (typeof window.upcartRefreshCart === 'function') {
          try { window.upcartRefreshCart(); } catch (err) {}
        }
        var opened = false;
        if (typeof window.upcartOpenCart === 'function') {
          try { window.upcartOpenCart(); opened = true; } catch (err) {}
        }
        if (!opened && window.UpCart && typeof window.UpCart.open === 'function') {
          try { window.UpCart.open(); opened = true; } catch (err) {}
        }
        if (!opened) {
          var toggle = document.querySelector('[data-action="open-mini-cart"], .t4s-mini-cart-toggle, .t4s-mc-toggle, #mini-cart-toggle, [data-toggle="t4s-mini-cart"]');
          if (toggle) { toggle.click(); opened = true; }
        }
        if (!opened) {
          var cartLink = document.querySelector('a[href="/cart"]');
          if (cartLink && cartLink.dataset && cartLink.dataset.drawerOpen !== undefined) {
            cartLink.click();
            opened = true;
          }
        }
        if (!opened) {
          try {
            window.dispatchEvent(new CustomEvent('s2t:open-cart-drawer', { bubbles: true, detail: data }));
          } catch (err) {}
        }
        setLabel(addedLabel);
        restore();
      })
      .catch(function (err) {
        console.error('[s2t-patches-hero] Add to cart failed:', err);
        setLoading(false);
        setLabel(defaultLabel);
        showError(err && err.message ? err.message : errorMessage);
      });
  });

  // ============================================================
  // Rating: swap the shop-wide fallback for Judge.me's badge once it
  // reports real reviews. Judge.me injects markup even at 0 reviews, so a
  // CSS :empty test is not enough — read data-number-of-reviews instead.
  // ============================================================
  (function () {
    var WATCH_MS = 12000;

    function reviewCount(root) {
      var badge = root.querySelector('.jdgm-preview-badge');
      if (!badge) return 0;
      return parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
    }
    function evaluate(root) {
      root.classList.toggle('s2t-patches-hero__rating--has-product-reviews', reviewCount(root) > 0);
    }
    function initOne(root) {
      evaluate(root);
      var obs = new MutationObserver(function () { evaluate(root); });
      obs.observe(root, { attributes: true, childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, WATCH_MS);
    }
    function boot() {
      var nodes = document.querySelectorAll('[data-s2t-pa-rating]');
      for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
  })();

  // ============================================================
  // Modals: shop reviews + patch size guide.
  // Moved to <body> on first open so the sticky / overflow:clip ancestors
  // can't trap them; references are cached on the section so they survive.
  // ============================================================
  (function () {
    var KINDS = [
      { open: '[data-s2t-pa-reviews-open]',    modal: '[data-s2t-pa-reviews-modal]',    close: '[data-s2t-pa-reviews-close]' },
      { open: '[data-s2t-pa-size-guide-open]', modal: '[data-s2t-pa-size-guide-modal]', close: '[data-s2t-pa-size-guide-close]' }
    ];
    function findModal(trigger, kind) {
      var section = trigger.closest('.s2t-patches-hero');
      if (!section) return null;
      section._s2tPaModals = section._s2tPaModals || {};
      if (section._s2tPaModals[kind.modal]) return section._s2tPaModals[kind.modal];
      var modal = section.querySelector(kind.modal);
      if (modal) {
        modal._s2tPaSection = section;
        section._s2tPaModals[kind.modal] = modal;
        document.body.appendChild(modal); // portal out
      }
      return modal;
    }
    function open(modal, trigger, kind) {
      modal.hidden = false;
      modal._s2tLastTrigger = trigger;
      document.body.classList.add('s2t-pa-modal-open');
      document.body.style.overflow = 'hidden';
      if (modal.hasAttribute('data-s2t-pa-size-guide-modal')) refreshSizeGuide(modal);
      var close = modal.querySelector(kind.close);
      if (close) close.focus();
    }
    function close(modal) {
      modal.hidden = true;
      document.body.classList.remove('s2t-pa-modal-open');
      document.body.style.overflow = '';
      if (modal._s2tLastTrigger) { try { modal._s2tLastTrigger.focus(); } catch (e) {} }
    }

    // ---- Size guide: locate the app's Width / Height inputs by their labels ----
    function fieldText(input) {
      // Climb while the ancestor still wraps only this one text/number input,
      // so a shared Width+Height container is never mistaken for a label.
      var el = input.parentElement, wrap = input, depth = 0;
      while (el && depth < 6 && el.querySelectorAll('input[type="number"], input[type="text"]').length === 1) { wrap = el; el = el.parentElement; depth++; }
      var t = (wrap.textContent || '') + ' ' + (input.name || '') + ' ' + (input.getAttribute('aria-label') || '') + ' ' + (input.getAttribute('placeholder') || '');
      if (input.id) { var l = document.querySelector('label[for="' + input.id + '"]'); if (l) t += ' ' + l.textContent; }
      return t.toLowerCase();
    }
    function findSizeInputs(section) {
      var form = section.querySelector('[data-s2t-pa-form]');
      if (!form) return null;
      var wKey = (section.getAttribute('data-s2t-pa-width-label') || 'width').toLowerCase();
      var hKey = (section.getAttribute('data-s2t-pa-height-label') || 'height').toLowerCase();
      var inputs = form.querySelectorAll('input[type="number"], input[type="text"]');
      var w = null, hh = null;
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.name === 'quantity' || input.hasAttribute('data-s2t-pa-qty')) continue;
        var text = fieldText(input);
        if (!w && text.indexOf(wKey) !== -1) { w = input; continue; }
        if (!hh && text.indexOf(hKey) !== -1) { hh = input; }
      }
      return (w && hh) ? { width: w, height: hh } : null;
    }
    function refreshSizeGuide(modal) {
      // Apply is offered whenever the app's Width / Height inputs can be found;
      // otherwise the guide is read-only (buttons and footnote hidden).
      var section = modal._s2tPaSection;
      var found = !!(section && findSizeInputs(section));
      var buttons = modal.querySelectorAll('[data-s2t-pa-size-apply]');
      for (var i = 0; i < buttons.length; i++) buttons[i].hidden = !found;
      var foot = modal.querySelector('[data-s2t-pa-size-footnote]');
      if (foot) foot.hidden = !found;
    }
    function setInput(input, value) {
      input.value = value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function applySize(btn) {
      var modal = btn.closest('[data-s2t-pa-size-guide-modal]');
      var row = btn.closest('[data-s2t-pa-size-row]');
      var section = modal && modal._s2tPaSection;
      if (!modal || !row || !section) return;
      var inputs = findSizeInputs(section);
      if (!inputs) return;
      setInput(inputs.width, row.getAttribute('data-width'));
      setInput(inputs.height, row.getAttribute('data-height'));
      close(modal);
    }

    // ---- Size guide link: move it beside the app's option heading once rendered ----
    function placeSizeGuideLink(section) {
      var wrap = section.querySelector('[data-s2t-pa-size-guide-link-wrap]');
      var form = section.querySelector('[data-s2t-pa-form]');
      if (!wrap || !form) return;
      var anchor = (wrap.getAttribute('data-anchor-text') || '').trim().toLowerCase();
      if (!anchor) return;
      var placed = false;
      function tryPlace() {
        if (placed) return;
        var host = form.querySelector('[data-s2t-pa-options]');
        var scope = host && host.nextElementSibling ? host.nextElementSibling : form; // the app's container
        var nodes = scope.querySelectorAll('label, legend, h2, h3, h4, h5, h6, p, span, div');
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (el === wrap || wrap.contains(el) || el.contains(wrap)) continue;
          var own = '';
          for (var c = 0; c < el.childNodes.length; c++) if (el.childNodes[c].nodeType === 3) own += el.childNodes[c].nodeValue;
          var text = (own.trim() || el.textContent.trim()).toLowerCase();
          if (text.length > 80 || text.indexOf(anchor) !== 0) continue;
          if (el.querySelector('input, select, button, textarea')) continue;
          placed = true;
          if (observer) observer.disconnect();
          wrap.classList.add('s2t-patches-hero__size-guide-link-wrap--inline');
          if (el.tagName === 'LABEL') el.insertAdjacentElement('afterend', wrap); else el.appendChild(wrap);
          return;
        }
      }
      var observer = new MutationObserver(tryPlace);
      observer.observe(form, { childList: true, subtree: true });
      tryPlace();
    }
    function initSizeGuides() {
      var sections = document.querySelectorAll('.s2t-patches-hero');
      for (var i = 0; i < sections.length; i++) placeSizeGuideLink(sections[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSizeGuides); else initSizeGuides();

    document.addEventListener('click', function (e) {
      var applyBtn = e.target.closest('[data-s2t-pa-size-apply]');
      if (applyBtn) { e.preventDefault(); applySize(applyBtn); return; }
      for (var k = 0; k < KINDS.length; k++) {
        var kind = KINDS[k];
        var opener = e.target.closest(kind.open);
        if (opener) {
          var modal = findModal(opener, kind);
          if (modal) { e.preventDefault(); e.stopPropagation(); open(modal, opener, kind); }
          return;
        }
        var closer = e.target.closest(kind.close);
        if (closer) {
          var m = closer.closest(kind.modal);
          if (m) close(m);
          return;
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelectorAll('[data-s2t-pa-reviews-modal]:not([hidden]), [data-s2t-pa-size-guide-modal]:not([hidden])');
      for (var i = 0; i < open.length; i++) close(open[i]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2t-product-hero"] && !Shopify.designMode) return;
  try {
    
  // ---------- Gallery thumbnail → main image swap ----------
  // Delegated, so all gallery instances on the page work via one handler.
  // Clicking a thumbnail:
  //   1. Updates main image src + srcset + alt
  //   2. Flips the --active class
  //   3. Updates aria-pressed for screen readers
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-s2t-ph-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('.s2t-product-hero__gallery');
    if (!gallery) return;

    var main = gallery.querySelector('[data-s2t-ph-main]');
    if (!main) return;

    var full = thumb.getAttribute('data-full');
    var srcset = thumb.getAttribute('data-srcset');
    var alt = thumb.getAttribute('data-alt');

    if (full) main.setAttribute('src', full);
    if (srcset) main.setAttribute('srcset', srcset);
    if (alt) main.setAttribute('alt', alt);

    // Flip --active state
    var allThumbs = gallery.querySelectorAll('[data-s2t-ph-thumb]');
    for (var i = 0; i < allThumbs.length; i++) {
      var t = allThumbs[i];
      var isActive = (t === thumb);
      t.classList.toggle('s2t-product-hero__thumb--active', isActive);
      t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  });

  // ---------- Tier picker → hidden quantity input + installments visibility ----------
  // On tier change: (1) write data-qty into the form's hidden quantity input
  // (drives ATC payload), and (2) show/hide the Shop Pay installments widget
  // based on whether the selected tier's quote would be accurate (single-buy)
  // or misleading (BOGO).
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.matches('.s2t-product-hero__tier-input')) return;

    var tiers = radio.closest('[data-s2t-ph-tiers]');
    if (!tiers) return;

    var qty = parseInt(radio.getAttribute('data-qty'), 10);
    if (!qty || qty < 1) qty = 1;

    var qtyInput = tiers.querySelector('[data-s2t-ph-qty]');
    if (qtyInput) qtyInput.value = qty;

    // Toggle the Shop Pay installments line based on the selected tier.
    // Shopify's payment_terms filter is variant-price-locked, so the real
    // widget's quote would mislead on BOGO tiers (per-sheet installment next
    // to a multi-sheet total). Swap to a generic "Buy now, pay later with
    // Shop Pay" block instead — same line, no misleading amounts.
    var section = radio.closest('.s2t-product-hero');
    var paidCents = parseInt(radio.getAttribute('data-paid-total-cents'), 10);
    if (section) {
      var installmentsEligible = radio.getAttribute('data-installments-eligible') === 'true';
      var widgetEl = section.querySelector('[data-s2t-ph-installments-widget]');
      var genericEl = section.querySelector('[data-s2t-ph-installments-generic]');
      if (widgetEl) widgetEl.style.display = installmentsEligible ? '' : 'none';
      if (genericEl) genericEl.style.display = installmentsEligible ? 'none' : '';
    }

    tiers.dispatchEvent(new CustomEvent('s2t:tier-changed', {
      bubbles: true,
      detail: { quantity: qty, paidCents: isNaN(paidCents) ? null : paidCents }
    }));
  });

  // ---------- Countdown timer ----------
  // Always counts down to the NEXT BUSINESS DAY's cutoff (configurable per
  // section). Weekend skip: if tomorrow is Sat/Sun, target rolls forward to
  // Monday. Timezone math handled via Intl.DateTimeFormat (DST-safe).
  //
  // Display format:
  //   ≥ 24h   → "Xd Yh"
  //   1h-24h  → "Hh Mm"
  //   < 1h    → "Mm"
  //
  // Template placeholders the merchant can use:
  //   {time}  → "Xh Ym" or "Xd Yh" or "Xm"
  //   {day}   → "Monday" / "Tuesday" / etc. (cutoff day name in the configured TZ)
  //   {date}  → e.g. "May 20"
  (function () {
    var nodes = document.querySelectorAll('[data-s2t-ph-countdown]');
    if (!nodes.length) return;

    function getNextDispatchTarget(hour, minute, timezone, skipWeekends) {
      var now = new Date();

      // 1. Today's Y-M-D in target TZ (ISO via sv-SE locale)
      var dateFmt = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric', month: '2-digit', day: '2-digit'
      });
      var todayParts = dateFmt.format(now).split('-').map(Number);

      // 2. Tomorrow as a local Date (day-of-week is timezone-agnostic
      //    because a calendar date IS a calendar date).
      var d = new Date(todayParts[0], todayParts[1] - 1, todayParts[2] + 1);

      // 3. Weekend skip
      if (skipWeekends) {
        var dow = d.getDay(); // 0=Sun .. 6=Sat
        if (dow === 6) d.setDate(d.getDate() + 2);      // Sat → Mon
        else if (dow === 0) d.setDate(d.getDate() + 1); // Sun → Mon
      }

      // 4. Build target = "y-m-d hour:minute" in the configured TZ as UTC ms.
      //    Trick: construct a UTC timestamp with the target wall-clock values,
      //    then ask Intl what that UTC moment is in the TZ. The difference
      //    tells us how much to shift to hit the desired wall-clock in TZ.
      var utcGuess = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), hour, minute, 0);
      var checkFmt = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        hour: '2-digit', minute: '2-digit', hour12: false
      });
      var actualParts = checkFmt.format(new Date(utcGuess)).split(':').map(Number);
      var wanted = hour * 60 + minute;
      var got = actualParts[0] * 60 + actualParts[1];
      var diff = wanted - got;
      if (diff > 12 * 60) diff -= 24 * 60;
      if (diff < -12 * 60) diff += 24 * 60;
      return new Date(utcGuess + diff * 60 * 1000);
    }

    function formatRemaining(ms) {
      if (ms <= 0) return '0m';
      var totalMinutes = Math.floor(ms / 60000);
      var days = Math.floor(totalMinutes / (24 * 60));
      var hours = Math.floor((totalMinutes % (24 * 60)) / 60);
      var minutes = totalMinutes % 60;
      if (days > 0) return days + 'd ' + hours + 'h';
      if (hours > 0) return hours + 'h ' + minutes + 'm';
      return minutes + 'm';
    }

    function render(node, target, template, timezone) {
      var remaining = target.getTime() - Date.now();
      if (remaining <= 0) return null; // signal that target needs recompute

      var dayFmt = new Intl.DateTimeFormat('en-US', { timeZone: timezone, weekday: 'long' });
      var dateFmt = new Intl.DateTimeFormat('en-US', { timeZone: timezone, month: 'short', day: 'numeric' });

      var text = template
        .replace('{time}', '__TIME__')
        .replace('{day}', dayFmt.format(target))
        .replace('{date}', dateFmt.format(target));

      // Inject the time as a styled <span> so CSS can highlight it
      // independently of the surrounding text.
      var timeSpan = '<span data-s2t-ph-countdown-time>' + formatRemaining(remaining) + '</span>';
      var html = text.replace('__TIME__', timeSpan);

      var slot = node.querySelector('[data-s2t-ph-countdown-text]');
      if (slot) slot.innerHTML = html;
      return target;
    }

    nodes.forEach(function (node) {
      var hour = parseInt(node.getAttribute('data-cutoff-hour'), 10);
      var minute = parseInt(node.getAttribute('data-cutoff-minute'), 10);
      if (isNaN(hour)) hour = 12;
      if (isNaN(minute)) minute = 0;
      var tz = node.getAttribute('data-cutoff-timezone') || 'America/New_York';
      var skipWeekends = node.getAttribute('data-skip-weekends') !== 'false';
      var template = node.getAttribute('data-template') || 'Order in {time} for {day} dispatch!';

      var target = getNextDispatchTarget(hour, minute, tz, skipWeekends);

      function tick() {
        var result = render(node, target, template, tz);
        if (result === null) {
          // Past the cutoff while the page was open — recompute
          target = getNextDispatchTarget(hour, minute, tz, skipWeekends);
          render(node, target, template, tz);
        }
      }

      tick();
      // Update every 60 seconds. setInterval is fine here — visible drift
      // is sub-second, negligible against an hours-long countdown.
      setInterval(tick, 60000);
    });
  })();

  // ---------- AJAX Add to Cart ----------
  // Intercept the product hero's form submit. POST to /cart/add.js (the
  // JSON endpoint, not /cart/add which redirects to the cart page). On
  // success, open the cart drawer using whatever's installed on the store.
  //
  // Drawer detection — try in order:
  //   1. UpCart (window.upcartRefreshCart + window.upcartOpenCart)
  //      OR window.UpCart.open() — what s2transfers.com is using today
  //   2. Kalles' built-in mini-cart — click an element with one of:
  //      [data-action="open-mini-cart"], .t4s-mini-cart-toggle,
  //      .t4s-mc-toggle, #mini-cart-toggle
  //   3. Dispatch a 's2t:open-cart-drawer' CustomEvent so any other app
  //      can listen and react
  //   4. Fall back to navigating /cart (only if behavior = "cart_page")
  //
  // Setting "After adding to cart" controls behavior:
  //   "drawer"    → open the drawer, stay on page (default)
  //   "cart_page" → navigate to /cart
  //   "stay"      → just show "Added ✓" feedback, do nothing else
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-s2t-ph-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[data-s2t-ph-atc-button]');
    var labelEl = form.querySelector('.s2t-product-hero__atc-label');
    var defaultLabel = form.getAttribute('data-label-default') || (labelEl ? labelEl.textContent.trim() : 'Add to Cart');
    var addingLabel = form.getAttribute('data-label-adding') || 'Adding…';
    var addedLabel = form.getAttribute('data-label-added') || 'Added ✓';
    var errorMessage = form.getAttribute('data-error-message') || 'Sorry, we couldn\'t add this to your cart. Please try again.';
    var behavior = form.getAttribute('data-cart-behavior') || 'drawer';

    function setLabel(text) { if (labelEl) labelEl.textContent = text; }
    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      submitBtn.classList.toggle('s2t-product-hero__atc-button--loading', loading);
    }
    function restore() {
      setTimeout(function () {
        setLoading(false);
        setLabel(defaultLabel);
      }, 1500);
    }

    setLoading(true);
    setLabel(addingLabel);

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var msg = (data && data.description) || (data && data.message) || errorMessage;
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function (data) {
        // Tell the cart-progress indicator to refetch /cart.js.
        try {
          window.dispatchEvent(new CustomEvent('s2t:cart-updated', {
            bubbles: true,
            detail: data
          }));
        } catch (e) {}

        // Cart-page behavior: just navigate
        if (behavior === 'cart_page') {
          window.location.href = '/cart';
          return;
        }

        // Stay-on-page behavior: just show feedback, don't open anything
        if (behavior === 'stay') {
          setLabel(addedLabel);
          restore();
          return;
        }

        // Default: open the drawer using whatever's available.
        var opened = false;

        // Refresh first if UpCart has the refresh API (so the count + line
        // items update before the panel slides in).
        if (typeof window.upcartRefreshCart === 'function') {
          try { window.upcartRefreshCart(); } catch (e) {}
        }

        // 1) UpCart (lowercase functions)
        if (typeof window.upcartOpenCart === 'function') {
          try { window.upcartOpenCart(); opened = true; } catch (e) {}
        }
        // 2) UpCart (PascalCase API)
        if (!opened && window.UpCart && typeof window.UpCart.open === 'function') {
          try { window.UpCart.open(); opened = true; } catch (e) {}
        }
        // 3) Kalles native mini-cart
        if (!opened) {
          var toggle = document.querySelector('[data-action="open-mini-cart"], .t4s-mini-cart-toggle, .t4s-mc-toggle, #mini-cart-toggle, [data-toggle="t4s-mini-cart"]');
          if (toggle) { toggle.click(); opened = true; }
        }
        // 4) Generic Shopify cart drawer trigger
        if (!opened) {
          var cartLink = document.querySelector('a[href="/cart"]');
          if (cartLink && cartLink.dataset && cartLink.dataset.drawerOpen !== undefined) {
            cartLink.click();
            opened = true;
          }
        }
        // 5) Final fallback: dispatch a CustomEvent + show success label
        if (!opened) {
          try {
            window.dispatchEvent(new CustomEvent('s2t:open-cart-drawer', {
              bubbles: true,
              detail: data
            }));
          } catch (e) {}
        }

        setLabel(addedLabel);
        restore();
      })
      .catch(function (err) {
        console.error('[s2t-product-hero] Add to cart failed:', err);
        setLoading(false);
        setLabel(defaultLabel);
        try { window.alert(err && err.message ? err.message : errorMessage); } catch (e) {}
      });
  });

  // ============================================================
  // Rating widget — product vs. shop fallback
  // ============================================================
  // Judge.me injects HTML into `.jdgm-preview-badge` even for products
  // with 0 reviews — and hides it via its own CSS — which broke the
  // CSS-only `:empty` fallback toggle. Instead, watch the preview
  // badge with a MutationObserver and read its `data-number-of-reviews`
  // attribute (the reliable signal Judge.me sets on its rendered output).
  // When > 0 we add the modifier class that shows the per-product badge
  // and hides the shop-wide fallback widget.
  (function () {
    var WATCH_MS = 12000;

    function getReviewCount(badgeContainer) {
      if (!badgeContainer) return 0;
      var candidates = [badgeContainer].concat(
        Array.prototype.slice.call(
          badgeContainer.querySelectorAll('[data-number-of-reviews]')
        )
      );
      var max = 0;
      for (var i = 0; i < candidates.length; i++) {
        var v = candidates[i].getAttribute && candidates[i].getAttribute('data-number-of-reviews');
        if (v == null) continue;
        var n = parseInt(v, 10);
        if (!isNaN(n) && n > max) max = n;
      }
      return max;
    }

    function evaluate(wrapper) {
      var badge = wrapper.querySelector('.jdgm-preview-badge');
      if (getReviewCount(badge) > 0) {
        wrapper.classList.add('s2t-product-hero__rating--has-product-reviews');
        return true;
      }
      return false;
    }

    function initOne(wrapper) {
      if (evaluate(wrapper)) return;
      var badge = wrapper.querySelector('.jdgm-preview-badge');
      if (!badge || typeof MutationObserver === 'undefined') return;

      var observer = new MutationObserver(function () {
        if (evaluate(wrapper)) observer.disconnect();
      });
      observer.observe(badge, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-number-of-reviews']
      });

      setTimeout(function () { observer.disconnect(); }, WATCH_MS);
    }

    function initAll() {
      document.querySelectorAll('[data-s2t-rating]').forEach(initOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  // ============================================================
  // Shop Reviews modal
  // ============================================================
  // Clicking the shop-reviews fallback button opens this modal instead
  // of navigating away. Inside it: Judge.me's `jdgm-all-reviews-widget`,
  // which renders the full shop review list with their own filter +
  // pagination UI. On first open we nudge Judge.me to (re-)scan + load
  // the widget in case it skipped it on initial page load (some Judge.me
  // versions skip widgets inside hidden containers).
  //
  // The modal is portaled to <body> on open to escape any local stacking
  // context, same pattern as the FBT quick-view modal in s2t-products.
  (function () {
    function portalToBody(modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    }

    function openModal(modal, trigger) {
      portalToBody(modal);
      modal._s2tLastTrigger = trigger || null;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('s2t-rv-open');

      var closeBtn = modal.querySelector('[data-s2t-reviews-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('s2t-rv-open');
      var lastTrigger = modal._s2tLastTrigger;
      if (lastTrigger && document.contains(lastTrigger)) {
        try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    // Cache modal reference on the section element so it survives the
    // portal-to-body move (the modal leaves the section's DOM subtree
    // on first open).
    function findModalForTrigger(trigger) {
      var section = trigger.closest('.s2t-product-hero');
      if (!section) return null;
      var modal = section._s2tReviewsModal || section.querySelector('[data-s2t-reviews-modal]');
      if (modal) section._s2tReviewsModal = modal;
      return modal;
    }

    // Open
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-s2t-reviews-open]');
      if (!trigger) return;
      var modal = findModalForTrigger(trigger);
      if (!modal) return;
      e.preventDefault();
      openModal(modal, trigger);
    });

    // Close — overlay or close button
    document.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-s2t-reviews-close]');
      if (!closer) return;
      var modal = closer.closest('[data-s2t-reviews-modal]');
      closeModal(modal);
    });

    // Close — Escape
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-s2t-reviews-modal]:not([hidden])').forEach(closeModal);
    });
  })();

  // ---------- Cart-progress indicator for Buy 2 Get 1 Free ----------
  // Reads /cart.js, counts items whose product carries the 'premade' tag,
  // and paints one of five messages (0 / mid / close / qualified / stacked).
  //
  // Tag check: /cart.js doesn't expose product tags, so for each unique
  // handle in the cart we lazy-fetch /products/{handle}.js once per
  // session (cached in sessionStorage). Typical cart has 1–4 unique
  // products → cheap, cached after first hit.
  //
  // Refresh triggers: own s2t:cart-updated (dispatched on ATC),
  // generic cart:updated (Sections API + some themes), upcart:cart-updated,
  // pageshow (bfcache return), visibilitychange → visible (tab return).
  (function () {
    var TAG_NAME = 'premade';
    var SESSION_KEY = 's2t:premade-tag-cache';
    var tagCache = {};
    try {
      var stored = window.sessionStorage.getItem(SESSION_KEY);
      if (stored) tagCache = JSON.parse(stored) || {};
    } catch (e) {}

    function persistCache() {
      try {
        window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(tagCache));
      } catch (e) {}
    }

    function fetchHandleTags(handle) {
      if (tagCache[handle] !== undefined) {
        return Promise.resolve(tagCache[handle]);
      }
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          var hasTag = !!(data && data.tags && data.tags.indexOf(TAG_NAME) !== -1);
          tagCache[handle] = hasTag;
          persistCache();
          return hasTag;
        })
        .catch(function () {
          tagCache[handle] = false;
          return false;
        });
    }

    function substitute(template, subs) {
      if (!template) return '';
      return template
        .replace(/\{count\}/g, subs.count != null ? subs.count : '')
        .replace(/\{threshold\}/g, subs.threshold != null ? subs.threshold : '')
        .replace(/\{in_cycle\}/g, subs.in_cycle != null ? subs.in_cycle : '')
        .replace(/\{to_qualify\}/g, subs.to_qualify != null ? subs.to_qualify : '')
        .replace(/\{claimed\}/g, subs.claimed != null ? subs.claimed : '')
        .replace(/\{plural\}/g, subs.plural != null ? subs.plural : '');
    }

    function paintAll(count) {
      document.querySelectorAll('[data-s2t-premade-progress]').forEach(function (el) {
        var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 2;
        var textEl = el.querySelector('[data-s2t-premade-progress-text]');
        if (!textEl) return;

        // BOGO cycle length = threshold + 1 (e.g. "buy 2 get 1 free" = 3-item cycle).
        // The first `threshold` items of each cycle are paid; the next item is the
        // free one that gets auto-discounted at checkout. So:
        //   - claimed   = freebies the customer has already added to cart
        //   - in_cycle  = position within the current cycle (0..threshold)
        //   - to_qualify = items still needed to qualify for the NEXT free sheet
        var cycleLen = threshold + 1;
        var claimed = Math.floor(count / cycleLen);
        var inCycle = count % cycleLen;
        var toQualify = threshold - inCycle;
        if (toQualify < 0) toQualify = 0;
        var plural = claimed === 1 ? '' : 's';
        var subs = {
          count: count,
          threshold: threshold,
          in_cycle: inCycle,
          to_qualify: toQualify,
          claimed: claimed,
          plural: plural
        };

        var template;
        if (count === 0) {
          template = el.getAttribute('data-msg-0');
        } else if (inCycle === threshold) {
          // Qualified — the customer has paid for `threshold` items in the
          // current cycle but hasn't added the free one yet.
          template = el.getAttribute('data-msg-qualified');
        } else if (claimed === 0) {
          // First cycle, working toward qualifying.
          template = (inCycle === threshold - 1)
            ? el.getAttribute('data-msg-close')
            : el.getAttribute('data-msg-mid');
        } else {
          // Already claimed ≥1 free; mid-stacked-cycle (inCycle 0..threshold-1).
          template = el.getAttribute('data-msg-stacked');
        }

        textEl.textContent = substitute(template, subs);
        // Green "earned" styling applies once the customer has either claimed
        // any freebie OR just qualified for one.
        el.classList.toggle(
          's2t-product-hero__progress--met',
          claimed > 0 || inCycle === threshold
        );
        el.setAttribute('data-premade-count', count);
        el.setAttribute('data-premade-claimed', claimed);
      });
    }

    var loadInFlight = null;
    function loadCart() {
      if (loadInFlight) return loadInFlight;
      loadInFlight = fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : { items: [] }; })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          // Group quantities by handle.
          var qtyByHandle = {};
          items.forEach(function (item) {
            var h = item.handle;
            if (!h) return;
            qtyByHandle[h] = (qtyByHandle[h] || 0) + (item.quantity || 0);
          });
          var handles = Object.keys(qtyByHandle);
          if (handles.length === 0) return paintAll(0);
          return Promise.all(handles.map(fetchHandleTags)).then(function (flags) {
            var premadeCount = 0;
            handles.forEach(function (h, i) {
              if (flags[i]) premadeCount += qtyByHandle[h];
            });
            paintAll(premadeCount);
          });
        })
        .catch(function () { paintAll(0); })
        .then(function () { loadInFlight = null; });
      return loadInFlight;
    }

    // Initial paint.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadCart);
    } else {
      loadCart();
    }

    // Refresh on our own ATC + on generic cart events + on tab return.
    window.addEventListener('s2t:cart-updated', function () { loadCart(); });
    window.addEventListener('cart:updated', function () { loadCart(); });
    window.addEventListener('upcart:cart-updated', function () { loadCart(); });
    window.addEventListener('pageshow', function () { loadCart(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') loadCart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2t-products"] && !Shopify.designMode) return;
  try {
    
  // ---------- Carousel arrows ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s2t-products-nav]');
    if (!btn) return;
    var rail = btn.closest('.s2t-products__rail');
    if (!rail) return;
    var grid = rail.querySelector('[data-s2t-products-grid]');
    if (!grid) return;
    var direction = btn.getAttribute('data-s2t-products-nav') === 'prev' ? -1 : 1;
    // Scroll by ~85% of the visible rail so each click reveals a full new set
    // while keeping a little context from the previous set.
    var distance = grid.clientWidth * 0.85;
    grid.scrollBy({ left: direction * distance, behavior: 'smooth' });
  });

  // ---------- AJAX Add-to-Cart ----------
  // Single-variant products: intercept the form submit, POST to
  // /cart/add.js, then either open the cart drawer (UpCart, Kalles
  // native, or a generic CustomEvent fallback) or navigate to /cart,
  // per the section's "After adding to cart" setting.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-s2t-products-add-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    var labelEl = form.querySelector('.s2t-products__card-button-label');
    var defaultLabel = form.getAttribute('data-label-default') || (labelEl ? labelEl.textContent : 'Add to Cart');
    var addingLabel = form.getAttribute('data-label-adding') || 'Adding…';
    var addedLabel = form.getAttribute('data-label-added') || 'Added ✓';
    var behavior = form.getAttribute('data-cart-behavior') || 'drawer';

    function setLabel(text) { if (labelEl) labelEl.textContent = text; }
    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      submitBtn.classList.toggle('s2t-products__card-button--loading', loading);
    }

    setLoading(true);
    setLabel(addingLabel);

    var formData = new FormData(form);

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (errData) {
            throw new Error(errData.description || errData.message || 'Add to cart failed');
          });
        }
        return r.json();
      })
      .then(function (data) {
        // Notify listeners (Shopify-standard "cart:added" + our own event).
        try { document.dispatchEvent(new CustomEvent('cart:added', { detail: data, bubbles: true })); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('s2t:cart-added', { detail: data, bubbles: true })); } catch (e) {}
        // Trigger the Premade PDP cart-progress IIFE (listens on window).
        try { window.dispatchEvent(new CustomEvent('s2t:cart-updated', { detail: data })); } catch (e) {}

        if (behavior === 'page') {
          window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? (window.Shopify.routes.root + 'cart') : '/cart';
          return;
        }

        // Try, in order: UpCart (current site), generic upcart object,
        // Kalles' mini-cart toggle, then a CustomEvent everyone can listen to.
        var opened = false;
        if (typeof window.upcartRefreshCart === 'function') {
          try { window.upcartRefreshCart(); } catch (e) {}
        }
        if (typeof window.upcartOpenCart === 'function') {
          try { window.upcartOpenCart(); opened = true; } catch (e) {}
        }
        if (!opened && window.UpCart && typeof window.UpCart.open === 'function') {
          try { window.UpCart.open(); opened = true; } catch (e) {}
        }
        if (!opened) {
          var kallesToggle = document.querySelector('[data-action="open-mini-cart"], .t4s-mini-cart-toggle, .t4s-mc-toggle, #mini-cart-toggle');
          if (kallesToggle) { kallesToggle.click(); opened = true; }
        }
        if (!opened) {
          // No drawer found — dispatch a final event for any other app to catch.
          try { window.dispatchEvent(new CustomEvent('s2t:open-cart-drawer', { detail: data })); } catch (e) {}
        }

        setLabel(addedLabel);
        setTimeout(function () {
          setLoading(false);
          setLabel(defaultLabel);
        }, 1500);
      })
      .catch(function (err) {
        console.error('[s2t-products] Add to cart failed:', err);
        setLoading(false);
        setLabel(defaultLabel);
        try {
          window.alert(err && err.message ? err.message : 'Sorry, we couldn\'t add this to your cart. Please try again.');
        } catch (e) {}
      });
  });

  // ---------- Wishlist (Kalles-compatible) ----------
  // Reads/writes the same localStorage key the Kalles theme uses for its
  // built-in wishlist: "t4s_wis", stored as a comma-separated string of
  // "id:VARIANT_ID" entries (NOT JSON). Items added here show up on the
  // store's existing /search/?view=wishlist page without any extra work.
  // We also keep [data-count-wishlist] header counters in sync so the
  // header heart icon shows the right number after a click.
  (function () {
    var STORAGE_KEY = 't4s_wis';
    var MAX_ITEMS = 50; // matches Kalles' own limit

    function readList() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        return raw.split(',').filter(function (s) { return s && s.indexOf('id:') === 0; });
      } catch (e) {
        return [];
      }
    }

    function writeList(list) {
      try {
        if (list.length === 0) {
          window.localStorage.removeItem(STORAGE_KEY);
        } else {
          window.localStorage.setItem(STORAGE_KEY, list.join(','));
        }
      } catch (e) {}
      try {
        window.dispatchEvent(new CustomEvent('s2t:wishlist-change', { detail: { count: list.length, items: list } }));
      } catch (e) {}
    }

    function syncButtons() {
      var list = readList();
      var buttons = document.querySelectorAll('[data-s2t-wishlist]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var id = btn.getAttribute('data-id');
        if (!id) continue;
        var key = 'id:' + id;
        var active = list.indexOf(key) !== -1;
        btn.classList.toggle('s2t-products__card-wishlist--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var label = active ? 'Remove from wishlist' : 'Add to wishlist';
        var tip = btn.querySelector('.s2t-products__card-wishlist-tip');
        if (tip) tip.textContent = label;
        btn.setAttribute('title', label);
        btn.setAttribute('aria-label', label);
      }
      var count = list.length;
      // Kalles header counter convention + our own optional counter.
      var counters = document.querySelectorAll('[data-count-wishlist], [data-s2t-wishlist-count]');
      for (var j = 0; j < counters.length; j++) {
        counters[j].textContent = count;
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-s2t-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-id');
      if (!id) return;
      var key = 'id:' + id;
      var list = readList();
      var idx = list.indexOf(key);
      if (idx === -1) {
        list.unshift(key); // newest first, matches Kalles
        if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
      } else {
        list.splice(idx, 1);
      }
      writeList(list);
      syncButtons();
    });

    // Cross-tab sync (someone wishlists from another open tab, or removes
    // an item from the Kalles wishlist page).
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY || e.key === null) syncButtons();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncButtons);
    } else {
      syncButtons();
    }
  })();

  // ---------- Mobile scroll indicator (thumb tracks scrollLeft) ----------
  //
  // For each carousel grid:
  //   - Compute thumb width = clientWidth / scrollWidth (clamped to 12%-100%)
  //   - Compute thumb position = scrollProgress * (100% - thumbWidth)
  //   - Hide the track entirely when there's nothing to scroll
  //
  // rAF-throttled on the scroll handler so it runs at most once per paint.
  (function () {
    var grids = document.querySelectorAll('[data-s2t-products-grid]');
    if (!grids.length) return;

    function updateThumb(grid) {
      var rail = grid.closest('.s2t-products__rail');
      if (!rail) return;
      var thumb = rail.querySelector('[data-s2t-products-scrollbar-thumb]');
      var track = rail.querySelector('[data-s2t-products-scrollbar]');
      if (!thumb || !track) return;

      var scrollable = grid.scrollWidth - grid.clientWidth;
      if (scrollable <= 0) {
        // Everything fits — no scroll possible, hide the indicator.
        track.style.display = 'none';
        return;
      }
      track.style.display = '';

      // Thumb width reflects the visible portion of the total scroll width.
      var ratio = grid.clientWidth / grid.scrollWidth;
      var thumbPct = Math.max(0.12, Math.min(1, ratio)) * 100;
      thumb.style.width = thumbPct + '%';

      // Thumb position reflects scroll progress within the track.
      var progress = grid.scrollLeft / scrollable;
      var travelPct = (100 - thumbPct) * progress;
      thumb.style.transform = 'translateX(' + travelPct + '%)';
    }

    grids.forEach(function (grid) {
      var ticking = false;
      grid.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateThumb(grid);
          ticking = false;
        });
      }, { passive: true });

      // Recompute on resize (orientation change, font load, etc.)
      window.addEventListener('resize', function () {
        updateThumb(grid);
      });

      // Initial paint — wait for layout to settle before first measurement.
      requestAnimationFrame(function () { updateThumb(grid); });
    });
  })();

  // ============================================================
  // Quick View Modal
  // ============================================================
  // Clicking a card's image or title (when the card opts in via
  // `data-s2t-qv-trigger`) opens a per-section modal pre-filled with
  // the clicked product's image, title, and a 2-tier picker priced
  // off the product's `data-qv-price-cents`. The modal's ATC submits
  // to /cart/add.js, closes itself, and opens the cart drawer using
  // the same UpCart → Kalles → CustomEvent fallback chain as the
  // card-level ATC above. The visitor never leaves the page.
  (function () {
    function formatMoneyCents(cents) {
      if (cents == null || isNaN(cents)) return '';
      var dollars = (Math.round(cents) / 100).toFixed(2);
      return '$' + dollars;
    }

    function interpolate(tpl, vars) {
      if (!tpl) return '';
      return tpl.replace(/\{(\w+)\}/g, function (_, k) {
        return vars[k] != null ? vars[k] : '';
      });
    }

    function openCartDrawer(data) {
      var opened = false;
      if (typeof window.upcartRefreshCart === 'function') {
        try { window.upcartRefreshCart(); } catch (e) {}
      }
      if (typeof window.upcartOpenCart === 'function') {
        try { window.upcartOpenCart(); opened = true; } catch (e) {}
      }
      if (!opened && window.UpCart && typeof window.UpCart.open === 'function') {
        try { window.UpCart.open(); opened = true; } catch (e) {}
      }
      if (!opened) {
        var kallesToggle = document.querySelector('[data-action="open-mini-cart"], .t4s-mini-cart-toggle, .t4s-mc-toggle, #mini-cart-toggle');
        if (kallesToggle) { kallesToggle.click(); opened = true; }
      }
      if (!opened) {
        try { window.dispatchEvent(new CustomEvent('s2t:open-cart-drawer', { detail: data })); } catch (e) {}
      }
    }

    function renderTiers(modal, productCents, productCompareCents) {
      var tiersWrap = modal.querySelector('[data-s2t-qv-tiers], .s2t-products__qv-tiers');
      if (!tiersWrap) return;

      var ds = modal.dataset;
      var sid = (modal.id || '').replace(/^s2t-products-qv-/, '') || 'qv';
      var hasProductCompare = productCompareCents > productCents;

      // Build a uniform tier descriptor for tiers 1..3 from dataset settings.
      // tier1 has no badge/bonus controls (single-buy), tiers 2/3 do. tier3
      // is optional — if the merchant left tier3 label blank, we skip it
      // and fall back to a 2-tier layout (preserves prior behavior).
      var tiers = [];

      tiers.push({
        idx: '1',
        label: ds.tier1Label || '1 Gang Sheet',
        qty: 1,
        paidQty: 1,
        unitTpl: ds.tier1PerUnit || '{price} each',
        badge: '',
        bonus: '',
        defaultSelected: false
      });

      tiers.push({
        idx: '2',
        label: ds.tier2Label || 'Buy 2 Get 1 Free',
        qty: parseInt(ds.tier2Qty, 10) || 3,
        paidQty: parseInt(ds.tier2PaidQty, 10) || 2,
        unitTpl: ds.tier2PerUnit || '{price_each} each',
        badge: ds.tier2Badge || '',
        bonus: ds.tier2Bonus || '',
        defaultSelected: ds.tier2Default === '1'
      });

      if (ds.tier3Label) {
        tiers.push({
          idx: '3',
          label: ds.tier3Label,
          qty: parseInt(ds.tier3Qty, 10) || 3,
          paidQty: parseInt(ds.tier3PaidQty, 10) || 3,
          unitTpl: ds.tier3PerUnit || '{price_each} each',
          badge: ds.tier3Badge || '',
          bonus: ds.tier3Bonus || '',
          defaultSelected: ds.tier3Default === '1'
        });
      }

      // Pick the selected tier: first one flagged default, else tier1.
      var defaultIdx = -1;
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].defaultSelected) { defaultIdx = i; break; }
      }
      if (defaultIdx === -1) defaultIdx = 0;

      function tierHTML(opts) {
        var checked = opts.selected ? 'checked' : '';
        var selClass = opts.selected ? ' s2t-products__qv-tier--selected' : '';
        var badgeHTML = opts.badge ? '<span class="s2t-products__qv-tier-badge">' + opts.badge + '</span>' : '';
        var compareHTML = opts.compareCents ? '<s class="s2t-products__qv-tier-compare">' + formatMoneyCents(opts.compareCents) + '</s>' : '';
        var bonusHTML = opts.bonus ? '<span class="s2t-products__qv-tier-bonus">' + opts.bonus + '</span>' : '<span></span>';
        return ''
          + '<div class="s2t-products__qv-tier' + selClass + '" data-s2t-qv-tier="' + opts.idx + '" data-qty="' + opts.qty + '">'
          + badgeHTML
          + '<input type="radio" class="s2t-products__qv-tier-input" name="s2t-qv-tier-' + sid + '" id="s2t-qv-tier-' + sid + '-' + opts.idx + '" value="' + opts.idx + '" ' + checked + '>'
          + '<label class="s2t-products__qv-tier-label" for="s2t-qv-tier-' + sid + '-' + opts.idx + '">'
          + '<span class="s2t-products__qv-tier-radio" aria-hidden="true"></span>'
          + '<span class="s2t-products__qv-tier-name">' + opts.label + '</span>'
          + '<span class="s2t-products__qv-tier-price">' + compareHTML + formatMoneyCents(opts.displayCents) + '</span>'
          + '<div class="s2t-products__qv-tier-meta">'
          + '<span class="s2t-products__qv-tier-unit">' + opts.unitText + '</span>'
          + bonusHTML
          + '</div>'
          + '</label>'
          + '</div>';
      }

      var html = '';
      for (var j = 0; j < tiers.length; j++) {
        var t = tiers[j];
        var displayCents = productCents * t.paidQty;
        var priceEachCents = Math.round(displayCents / t.qty);
        // Compare-at: a "BOGO-style" tier (paidQty < qty) always shows its
        // own compare = full unit price × qty. Otherwise show the product's
        // own compare-at (× qty) only when it's actually higher than price.
        var compareCents;
        if (t.paidQty < t.qty) {
          compareCents = productCents * t.qty;
        } else if (hasProductCompare) {
          compareCents = productCompareCents * t.qty;
        } else {
          compareCents = 0;
        }
        html += tierHTML({
          idx: t.idx,
          label: t.label,
          qty: t.qty,
          displayCents: displayCents,
          compareCents: compareCents,
          unitText: interpolate(t.unitTpl, {
            price: formatMoneyCents(displayCents),
            price_each: formatMoneyCents(priceEachCents)
          }),
          bonus: t.bonus,
          badge: t.badge,
          selected: j === defaultIdx
        });
      }

      tiersWrap.innerHTML = html;

      // Sync initial hidden quantity to selected tier.
      var selectedTier = tiersWrap.querySelector('.s2t-products__qv-tier--selected');
      var qtyInput = modal.querySelector('[data-s2t-qv-qty]');
      if (selectedTier && qtyInput) qtyInput.value = selectedTier.getAttribute('data-qty') || '1';
    }

    function openModal(modal, data) {
      // Portal the modal to <body> on first open. The s2t-products section
      // creates a local stacking context (`isolation: isolate`), which would
      // otherwise scope the modal's z-index inside the section — letting
      // later siblings (e.g. the product description section below the FBT
      // carousel) render ON TOP of the modal. Moving the modal to <body>
      // lifts it into the top-level stacking context where z-index works
      // as expected.
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      var img = modal.querySelector('[data-s2t-qv-image]');
      var titleEl = modal.querySelector('[data-s2t-qv-title]');
      var variantInput = modal.querySelector('[data-s2t-qv-variant]');
      var urlLink = modal.querySelector('[data-s2t-qv-url]');
      var errorEl = modal.querySelector('[data-s2t-qv-error]');
      var atcBtn = modal.querySelector('[data-s2t-qv-atc]');
      var atcLabel = modal.querySelector('[data-s2t-qv-atc-label]');

      if (img) {
        img.src = data.image || '';
        img.alt = data.title || '';
      }
      if (titleEl) titleEl.textContent = data.title || '';
      if (variantInput) variantInput.value = data.variantId || '';
      if (urlLink) urlLink.href = data.url || '#';
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (atcBtn) { atcBtn.disabled = false; }
      if (atcLabel) atcLabel.textContent = modal.getAttribute('data-atc-label') || 'Add to Cart';

      renderTiers(modal, parseInt(data.priceCents, 10) || 0, parseInt(data.compareCents, 10) || 0);

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('s2t-qv-open');

      // Focus the close button so keyboard users can Escape out immediately.
      var closeBtn = modal.querySelector('[data-s2t-qv-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('s2t-qv-open');
      // Restore focus to the trigger element that opened the modal.
      var lastTrigger = modal._s2tLastTrigger;
      if (lastTrigger && document.contains(lastTrigger)) {
        try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    // ---------- Open: delegated click on `[data-s2t-qv-trigger]` ----------
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-s2t-qv-trigger]');
      if (!trigger) return;
      var sectionEl = trigger.closest('.s2t-products');
      if (!sectionEl) return;
      // Cache the modal on the section so we can find it after we portal
      // it to <body> (where it leaves the section's DOM subtree).
      var modal = sectionEl._s2tQvModal || sectionEl.querySelector('[data-s2t-products-qv]');
      if (!modal) return;
      sectionEl._s2tQvModal = modal;
      if (!modal) return;
      e.preventDefault();

      modal._s2tLastTrigger = trigger;
      openModal(modal, {
        handle: trigger.getAttribute('data-qv-handle') || '',
        variantId: trigger.getAttribute('data-qv-variant-id') || '',
        image: trigger.getAttribute('data-qv-image') || '',
        title: trigger.getAttribute('data-qv-title') || '',
        url: trigger.getAttribute('data-qv-url') || '#',
        priceCents: trigger.getAttribute('data-qv-price-cents') || '0',
        compareCents: trigger.getAttribute('data-qv-compare-cents') || '0'
      });
    });

    // ---------- Close: overlay click, close button, Escape ----------
    document.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-s2t-qv-close]');
      if (!closer) return;
      var modal = closer.closest('[data-s2t-products-qv]');
      closeModal(modal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openModals = document.querySelectorAll('[data-s2t-products-qv]:not([hidden])');
      openModals.forEach(closeModal);
    });

    // ---------- Tier click: visual select + hidden qty sync ----------
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.s2t-products__qv-tier-input')) return;
      var tiersWrap = e.target.closest('.s2t-products__qv-tiers');
      if (!tiersWrap) return;
      tiersWrap.querySelectorAll('.s2t-products__qv-tier').forEach(function (t) {
        t.classList.remove('s2t-products__qv-tier--selected');
      });
      var pickedTier = e.target.closest('.s2t-products__qv-tier');
      if (pickedTier) pickedTier.classList.add('s2t-products__qv-tier--selected');

      var modal = e.target.closest('[data-s2t-products-qv]');
      var qtyInput = modal && modal.querySelector('[data-s2t-qv-qty]');
      if (pickedTier && qtyInput) qtyInput.value = pickedTier.getAttribute('data-qty') || '1';
    });

    // Clicking the tier card itself (not just the radio) should also select.
    document.addEventListener('click', function (e) {
      var tier = e.target.closest('.s2t-products__qv-tier');
      if (!tier) return;
      // If they clicked the label or the radio, the native change handler
      // above will fire — don't double-handle here.
      if (e.target.closest('label, input')) return;
      var input = tier.querySelector('input.s2t-products__qv-tier-input');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // ---------- Submit: AJAX ATC ----------
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-s2t-qv-form]');
      if (!form) return;
      e.preventDefault();

      var modal = form.closest('[data-s2t-products-qv]');
      var atcBtn = form.querySelector('[data-s2t-qv-atc]');
      var atcLabel = form.querySelector('[data-s2t-qv-atc-label]');
      var errorEl = form.querySelector('[data-s2t-qv-error]');
      var defaultLabel = modal.getAttribute('data-atc-label') || 'Add to Cart';
      var addingLabel = modal.getAttribute('data-atc-label-adding') || 'Adding…';
      var addedLabel = modal.getAttribute('data-atc-label-added') || 'Added ✓';

      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (atcBtn) atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = addingLabel;

      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (errData) {
              throw new Error(errData.description || errData.message || 'Add to cart failed');
            });
          }
          return r.json();
        })
        .then(function (data) {
          try { document.dispatchEvent(new CustomEvent('cart:added', { detail: data, bubbles: true })); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('s2t:cart-added', { detail: data, bubbles: true })); } catch (e) {}
          // Trigger the Premade PDP cart-progress IIFE (listens on window).
          try { window.dispatchEvent(new CustomEvent('s2t:cart-updated', { detail: data })); } catch (e) {}

          if (atcLabel) atcLabel.textContent = addedLabel;

          // Close the modal, then open the cart drawer. Slight delay
          // so the "Added ✓" flash is visible.
          setTimeout(function () {
            closeModal(modal);
            openCartDrawer(data);
            if (atcLabel) atcLabel.textContent = defaultLabel;
            if (atcBtn) atcBtn.disabled = false;
          }, 350);
        })
        .catch(function (err) {
          console.error('[s2t-products quick view] Add to cart failed:', err);
          if (atcLabel) atcLabel.textContent = defaultLabel;
          if (atcBtn) atcBtn.disabled = false;
          if (errorEl) {
            errorEl.textContent = (err && err.message) ? err.message : "Sorry, we couldn't add that to your cart. Please try again.";
            errorEl.hidden = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s2t-video"] && !Shopify.designMode) return;
  try {
    
  // Mobile video lazy-load with viewport gate.
  //
  // <source> tags ship with data-src instead of src so the browser
  // doesn't fetch the video on initial page load. This script:
  //   1. Checks the viewport width
  //   2. Reads the "load on mobile" flag from data-load-on-mobile
  //   3. If conditions are met, copies data-src → src on every <source>,
  //      calls video.load(), and tries to play()
  //   4. Respects prefers-reduced-motion (skip play if user wants less motion)
  //
  // Result: mobile visitors with the setting off save megabytes;
  // desktop visitors get the video as expected.
  (function () {
    var videos = document.querySelectorAll('[data-s2t-video-bg]');
    if (!videos.length) return;

    var reducedMotion = false;
    try {
      reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    var isMobile = false;
    try {
      isMobile = window.matchMedia('(max-width: 1023px)').matches;
    } catch (e) {}

    videos.forEach(function (video) {
      var loadOnMobile = video.getAttribute('data-load-on-mobile') === 'true';
      if (reducedMotion) {
        // Honour the OS preference — leave the poster image in place,
        // don't load the video at all.
        return;
      }
      if (isMobile && !loadOnMobile) return;

      // Promote data-src → src on every source element.
      var sources = video.querySelectorAll('source[data-src]');
      var swapped = false;
      sources.forEach(function (src) {
        var url = src.getAttribute('data-src');
        if (!url) return;
        src.setAttribute('src', url);
        src.removeAttribute('data-src');
        swapped = true;
      });
      if (!swapped) return;

      // Tell the browser to (re)load with the new sources, then play.
      try { video.load(); } catch (e) {}
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        // Some browsers reject autoplay when the tab isn't focused; that
        // rejection is harmless — the user can interact to play.
        playPromise.catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
